<!--
 * @Author: zly
 * @Date: 2024-08-20 10:29:43
 * @LastEditTime: 2024-12-02 18:06:55
 * @LastEditors: zly
 * @Description: supcon
-->
<template>
  <div class="supcon_box" v-loading="reqLoading">
    <div class="banner">
      <img src="~@/assets/img/supcon/banner.png" alt="" srcset="" />
    </div>
    <div class="gradient"></div>
    <div class="content_box">
      <div class="content_title">
        {{navList[navAvtiveIndex].name}} ZONE
      </div>
      <div class="content_title1">
        {{navList[navAvtiveIndex].name}} 专区
      </div>
      <div class="list" ref=''>
        <div class="list-item" v-for="item in goodList" :key="item.id" @click="goDetail(item)">
          <div class="img-box">
            <el-image
              v-show="item.fileUrl"
              :src="item.fileUrl"
              class="goodsImg"
              fit="contain"
            >
              <template slot="error">
                <img src="~@/assets/img/bitmap.png" class="goodsImg" />
              </template>
            </el-image>
            <img
              src="~@/assets/img/bitmap.png"
              v-show="!item.fileUrl"
              alt=""
              width="208px"
              height="208px"
            />
          </div>
          <div style="padding: 0 20px">
            <div class="title multi_line_overflow">
              {{item.name}}
            </div>
            <div class="series ellipsis">
              {{item.supplyCommodityCode}}
            </div>
            <div
              class="price price_text"
              v-show="
                (item.commodityType &&
                  item.commodityType.indexOf('非标') > -1) ||
                item.isSellingPriceExpire
              "
            >
              {{ $t("home.rfq") }}
            </div>
            <!-- <good-price :price="Number(item.minPrice) || 0"></good-price> -->
            <good-price
              v-show="
                item.commodityType &&
                item.commodityType.indexOf('非标') === -1 &&
                !item.isSellingPriceExpire
              "
              :price="Number(item.minPrice) || 0"
            ></good-price>
            <!-- <div class="org_price">划线价999.00</div> -->
          </div>
        </div>
      </div>
      <!-- 悬浮导航栏 -->
      <div class="fixed_nav_box">
        <div class="fixed_nav">
          <div
            class="nav_item ellipsis"
            :class="{ active: navAvtiveIndex == index }"
            v-for="(item, index) in navList"
            :key="item.id"
            @click="navItemBtn(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <el-pagination ref="goodListRef" style="visibility: hidden; opacity: 0">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import GoodPrice from '@/components/good-price'
import { openOther, isElementInViewport } from '@/utils'

export default {
  data () {
    return {
      reqLoading: false,
      goodList: [],
      page: 1,
      total: 0,
      navList: [{}],
      navAvtiveIndex: 0
    }
  },
  components: {
    GoodPrice
  },
  mounted () {
    window.addEventListener('scroll', this.lazyLoading) // 滚动到底部，再加载的处理事件
    this.getNavList();
  },
  destroyed () {
    window.removeEventListener('scroll', this.lazyLoading)
  },
  methods: {
    getNavList () {
      this.$http
        .post(`/front/cross/commodity-user/web/condition?conditionType=${''}`, {
          foregroundCategoryId: '311901392287567872'
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.navList = res.data.foregroundCategoryWithParentChainSubnodeList.subNodeList || []
          this.refushDataList(1)
        });
    },
    // 导航栏点击
    navItemBtn (val, index) {
      this.navAvtiveIndex = index
      this.refushDataList(1)
    },
    // 获取商品列表
    refushDataList (page = this.page, reset = true) {
      if (this.reqLoading) {
        return false
      }
      this.reqLoading = true
      this.page = page
      if (page === 1) {
        this.goodList = []
        this.total = 0
        this.attributePage = 1
      }
      this.$http
        .post(`/front/cross/commodity-user/web/spu-list`, {
          limit: 20,
          page: page,
          search: '', // 搜索内容
          brandIdList: [], // 品牌主键列表
          seriesNameList: [], // 系列主键列表
          attributeValueIdList: [], // 属性值主键列表
          foregroundCategoryId: this.navList[this.navAvtiveIndex].foregroundCategoryId, // 前台类目主键
          salesDesc: false,
          priceDesc: false
          // popularityDesc: this.popularityDesc
        })
        .then(({ data: res }) => {
          this.reqLoading = false
          if (res.code !== 0) {
            this.goodList = []
            this.total = 0
            return false
          }
          if (reset) {
            this.goodList.push(...(res.data.dataList || []))
          } else {
            this.goodList = res.data.dataList || []
          }
          this.total = res.data.count
        })
        .catch(() => {
          this.reqLoading = false
          this.goodList = []
          this.total = 0
        })
    },
    lazyLoading () {
      if (isElementInViewport(this.$refs.goodListRef.$el)) {
        if (this.goodList.length >= this.total) return
        this.load()
      }
    },
    load () {
      let current = this.page
      current++
      this.refushDataList(current)
    },
    pageSizeChangeHandle (val) {},
    // 跳转页
    getDataList (val) {
      this.refushDataList(val)
    },
    // 跳转详情页
    goDetail (goods) {
      openOther(`goodDetail?spuId=${goods.spuId}&skuId=`)
    }
  }
}
</script>

<style lang="scss" scoped>
.cooperation {
  width: 1190px;
  margin: 10px auto;
  background: #fff;
  padding: 20px 0;
}
.banner {
  width: 100%;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.gradient {
  width: 100%;
  height: 100px;
  background: linear-gradient(180deg, #037aff, rgb(42, 84, 209) 98%);
}
.content_box {
  width: 100%;
  padding: 0 20px 200px;
  background: #2a54d1;
  min-height: calc(100vh - 321px);
  .content_title {
    font-family: Alimama ShuHeiTi;
    font-size: 64px;
    font-weight: bold;
    line-height: normal;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0em;
    // background: linear-gradient(to bottom, #fff, #cac6c6);
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: #c7c5c5;
    opacity: 0.5;
    // -webkit-background-clip: text;
    -webkit-text-fill-color : transparent;
    // color: #fff;
    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
  }
  .content_title1 {
    font-family: AlibabaPuHuiTi;
    font-size: 40px;
    font-weight: bold;
    line-height: normal;
    text-align: center;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #FFFFFF;
    margin: -25px auto 50px;
  }
  .list {
    max-width: 1210px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 0 auto;
    .list-item {
      width: 19%;
      height: 268px;
      display: block;
      background: #fff;
      border-radius: 20px;
      margin-bottom: 30px;
      margin-right: 1%;
      transition: all 0.3s ease-in-out;
      &:hover {
        transition: all 0.3s ease-in-out;
        box-shadow: 0px 3px 6px 0px rgba(255, 255, 255, 0.4);
        // padding-top: 10px;
        height: 287px;
        margin-top: -22px;
        cursor: pointer;
      }
      .img-box {
        width: 129px;
        height: 105px;
        margin: 30px auto 2px;
        img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
        .goodsImg {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .title {
        font-family: AlibabaPuHuiTi;
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0em;
        font-variation-settings: "opsz" auto;
        color: #1a1a1a;
        height: 42px;
      }
      .series {
        font-family: AlibabaPuHuiTi;
        font-size: 12px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;
        height: 20px;
        font-variation-settings: "opsz" auto;
        color: #646566;
        margin-top: 10px;
      }
      .price_text {
        font-size: 20px;
      }
      /deep/ .price {
        margin-top: 10px;
        color: #e93037;
        font-weight: bold;
        .price-int {
          font-size: 20px;
        }
        .price-point {
          font-size: 10px;
        }
      }
    }
  }
  .fixed_nav_box {
    padding: 5px;
    padding-right: 3px;
    position: fixed;
    background: #f1f5fb;
    border-radius: 16px;
    top: 35vh;
    right: 16px;
    .fixed_nav {
      height: 300px;
      overflow-y: scroll;
      .nav_item {
        width: 120px;
        padding: 0 10px;
        height: 51px;
        text-align: center;
        line-height: 51px;
        border-radius: 16px;
        cursor: pointer;
        &:hover {
          background: linear-gradient(
              0deg,
              rgba(42, 84, 209, 0.1),
              rgba(42, 84, 209, 0.1)
            ),
            #ffffff;
        }
      }
      .active {
        background: #ffffff !important;
      }
    }
    .fixed_nav::-webkit-scrollbar {
      width: 6px;
      height: 10px;
      /**/
    }
    .menu-left::-webkit-scrollbar {
      display: none; /*隐藏滚动条*/
    }
    .fixed_nav::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 2px;
    }
    .fixed_nav::-webkit-scrollbar-thumb {
      background: #b1bdc9;
      border-radius: 10px;
    }
    .fixed_nav::-webkit-scrollbar-thumb:hover {
      background: rgb(139, 176, 231);
    }
    .fixed_nav::-webkit-scrollbar-corner {
      background: #1d65a8;
    }
  }
}
</style>
